// extracted by mini-css-extract-plugin
export default {"errorContainer":"Oops_errorContainer__r1qjI","errorImage":"Oops_errorImage__Zqa5N","errorText":"Oops_errorText__EcKEG","errorButton":"Oops_errorButton__xIX++"};